import React from 'react'

const GoogleRatingSection = () => {
  return (
    <div>GoogleRatingSection</div>
  )
}

export default GoogleRatingSection;